import ArrowRightIcon from './Icons/ArrowRightIcon';
import PortalPickerSubmenu from './PortalPickerSubmenu';
import { useTranslation } from '../../hooks/useNavConfig';
import { MenuPicker } from '../Menu';
import { Text } from 'breadcrumbs-ui/components/Text';
import { memoWithDisplayName } from 'react-utils/memoWithDisplayName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const _HublessPortalPicker = ({
  accounts
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(MenuPicker, {
    id: "navAccount-current",
    "aria-owns": "navAccountSwitcher",
    "aria-controls": "navAccountSwitcher",
    "data-test-id": "nav-account-menu-portal-picker",
    "aria-label": t('nav.tools.accounts'),
    submenu: /*#__PURE__*/_jsx(PortalPickerSubmenu, {
      accounts: accounts
    }),
    children: [/*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      typography: "heading-50",
      whiteSpace: "pre-wrap",
      textDecoration: "none",
      children: t('nav.tools.accounts')
    }), /*#__PURE__*/_jsx(ArrowRightIcon, {})]
  });
};
export const HublessPortalPicker = memoWithDisplayName('HublessPortalPicker', _HublessPortalPicker);